// 生薬名の漢字 → カタカナ マッピング
export const herbKanjiToKatakana = {
  "阿膠": "アキョウ",
  "威霊仙": "イレイセン",
  "茵陳蒿": "インチンコウ",
  "茴香": "ウイキョウ",
  "延胡索": "エンゴサク",
  "黄耆": "オウギ",
  "黄芩": "オウゴン",
  "黄柏": "オウバク",
  "黄連": "オウレン",
  "遠志": "オンジ",
  "艾葉": "ガイヨウ",
  "何首烏": "カシュウ",
  "葛根": "カッコン",
  "滑石": "カッセキ",
  "栝楼根": "カロコン",
  "栝楼仁": "カロニン",
  "乾姜": "カンキョウ",
  "甘草": "カンゾウ",
  "桔梗": "キキョウ",
  "菊花": "キクカ",
  "枳実": "キジツ",
  "羗活": "キョウカツ",
  "杏仁": "キョウニン",
  "苦参": "クジン",
  "荊芥": "ケイガイ",
  "桂皮": "ケイヒ",
  "紅花": "コウカ",
  "紅参": "コウジン",
  "紅参末": "コウジンマツ",
  "香附子": "コウブシ",
  "粳米": "コウベイ",
  "厚朴": "コウボク",
  "牛膝": "ゴシツ",
  "呉茱萸": "ゴシュユ",
  "牛蒡子": "ゴボウシ",
  "胡麻": "ゴマ",
  "胡麻油": "ゴマアブラ",
  "五味子": "ゴミシ",
  "柴胡": "サイコ",
  "細辛": "サイシン",
  "晒蜜蝋": "サラシミツロウ",
  "山査子": "サンザシ",
  "山梔子": "サンシシ",
  "山茱萸": "サンシュユ",
  "山椒": "サンショウ",
  "酸棗仁": "サンソウニン",
  "山薬": "サンヤク",
  "地黄": "ジオウ",
  "地骨皮": "ジコッピ",
  "紫根": "シコン",
  "蒺藜子": "シツリシ",
  "炙甘草": "シャカンゾウ",
  "芍薬": "シャクヤク",
  "車前子": "シャゼンシ",
  "縮砂": "シュクシャ",
  "生姜": "ショウキョウ",
  "小麦": "ショウバク",
  "升麻": "ショウマ",
  "辛夷": "シンイ",
  "石膏": "セッコウ",
  "川芎": "センキュウ",
  "前胡": "ゼンコ",
  "川骨": "センコツ",
  "蝉退": "センタイ",
  "蒼朮": "ソウジュツ",
  "桑白皮": "ソウハクヒ",
  "蘇木": "ソボク",
  "蘇葉": "ソヨウ",
  "大黄": "ダイオウ",
  "大棗": "タイソウ",
  "沢瀉": "タクシャ",
  "竹茹": "チクジョ",
  "知母": "チモ",
  "茶葉": "チャヨウ",
  "丁子": "チョウジ",
  "釣藤鈎": "チョウトウコウ",
  "猪苓": "チョレイ",
  "陳皮": "チンピ",
  "天南星": "テンナンショウ",
  "天麻": "テンマ",
  "天門冬": "テンモンドウ",
  "冬瓜子": "トウガシ",
  "当帰": "トウキ",
  "桃仁": "トウニン",
  "独活": "ドクカツ",
  "杜仲": "トチュウ",
  "鳥頭": "トリカブト",
  "豚脂": "トンシ",
  "呑子": "トンジ",
  "人参": "ニンジン",
  "忍冬": "ニンドウ",
  "貝母": "バイモ",
  "麦芽": "バクガ",
  "麦門冬": "バクモンドウ",
  "薄荷": "ハッカ",
  "浜防風": "ハマボウフウ",
  "半夏": "ハンゲ",
  "百合": "ビャクゴウ",
  "白芷": "ビャクシ",
  "白朮": "ビャクジュツ",
  "枇杷葉": "ビワヨウ",
  "檳榔子": "ビンロウジ",
  "茯苓": "ブクリョウ",
  "附子": "ブシ",
  "附子末": "ブシマツ",
  "防已": "ボウイ",
  "芒硝": "ボウショウ",
  "防風": "ボウフウ",
  "樸樕": "ボクソク",
  "朴樕": "ボクソク",
  "牡丹皮": "ボタンピ",
  "牡蛎": "ボレイ",
  "麻黄": "マオウ",
  "麻子仁": "マシニン",
  "木通": "モクツウ",
  "木香": "モッコウ",
  "薏苡仁": "ヨクイニン",
  "竜眼肉": "リュウガンニク",
  "龍骨": "リュウコツ",
  "竜胆": "リュウタン",
  "良姜": "リョウキョウ",
  "連翹": "レンギョウ",
  "蓮肉": "レンニク",
  "和羗活": "ワキョウカツ",
};

// カタカナ → 漢字 マッピング（逆引き用）
export const herbKatakanaToKanji = Object.entries(herbKanjiToKatakana).reduce((acc, [kanji, katakana]) => {
  acc[katakana] = kanji;
  return acc;
}, {});

// 生薬セット（カンマ区切り文字列）を漢字からカタカナに変換
export const convertHerbSetToKatakana = (herbSetKanji) => {
  return herbSetKanji.split(",").map(herb => herbKanjiToKatakana[herb] || herb).join(",");
};

// 生薬セット（カンマ区切り文字列）をカタカナから漢字に変換
export const convertHerbSetToKanji = (herbSetKatakana) => {
  return herbSetKatakana.split(",").map(herb => herbKatakanaToKanji[herb] || herb).join(",");
};

// 生薬配列を漢字からカタカナに変換
export const convertHerbArrayToKatakana = (herbArrayKanji) => {
  return herbArrayKanji.map(herb => herbKanjiToKatakana[herb] || herb);
};

// 生薬配列をカタカナから漢字に変換
export const convertHerbArrayToKanji = (herbArrayKatakana) => {
  return herbArrayKatakana.map(herb => herbKatakanaToKanji[herb] || herb);
};
